import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cb65d6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View transaction details", -1))

import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/solid';
import { URLs } from '@manifoldxyz/js-ts-utils';

interface TransactionDetailsProps {
  transactionHash: string;
  networkId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionDetails',
  props: {
    transactionHash: {},
    networkId: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "checkout-tx-hash",
    href: `${_unref(URLs).getEtherscanURLForTransactionHash(props.networkId, _ctx.transactionHash)}`,
    target: "_blank"
  }, [
    _hoisted_2,
    _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "link-icon" })
  ], 8, _hoisted_1))
}
}

})